/* eslint-disable react/jsx-one-expression-per-line */
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  message,
  Form,
  DatePicker,
  Select,
  Icon,
  Popover,
  Pagination,
} from 'antd';
import { layout, Button, ExTable } from 'icsoc-antd-ex';
import tDetailActions from 'Actions/taskManage/detail';
import tStatisticActions from 'Actions/taskManage/statistic';
// import {translateObjToString} from 'Utils';
// import Pagination from 'Components/common/pagination';
import FilterTree from './filterTree';
import ReloadModal from '../../systemSetting/exportTasks/modal/reloadModal';
import moment from 'moment';
import './index.less';
import login from '../../../reducers/login';

const { BaseContentMainHeader } = layout;
const { BaseTable, Filter } = ExTable;
const { RangePicker } = DatePicker;
const FormItem = Form.Item;
const { NormalFilter } = Filter;
const { Option } = Select;
let inSearch = false
class Statistic extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reloadModalVisible: false, // 重新创建弹框是否可见
      pageType: 'statistic',
      pagination: {
        current: 1,
        pageSize: 20,
      },
      total: 0,
      loading: false,
      values: {
        date: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
      },
      list: [],
      totalColumn: {},
      // total: 0,
      visible: false,
      columns: [],
      tableWidth: 2340,
      select:
        'taskName,dayStr,totalNum,calledNum,answerNum,answerRate,user,unknown,timeout,normal,others,noUsefulInteractNum,oneUsefulInteractNum,moreUsefulInteractNum,unknownNum,timeoutNum,labelDistinctCountMap',
    };
  }

  componentDidMount() {
    const { DetailActions } = this.props;
    DetailActions.getTaskNameOptions();
    this.getTotal();
  }

  defaultCoulumns = list => [
    {
      title: '序号',
      dataIndex: 'number',
      key: 'number',
      width: 60,
      fixed: 'left',
      render: (text, record, index) => {
        const obj = {
          children: index + 1,
          props: {},
          className: '',
        };
        if (index === list.length - 1) {
          obj.props.colSpan = 0;
          obj.className = 'totalRow';
        }
        return obj;
      },
    },
    {
      title: '任务名称',
      dataIndex: 'taskName',
      key: 'taskName',
      fixed: 'left',
      ellipsis: true,
      width: 190,
      render: (text, record, index) => {
        if (index === list.length - 1) {
          return {
            children: (
              <div style={{ textAlign: 'center', fontWeight: 700 }}>总计</div>
            ),
            props: {
              colSpan: 3,
            },
            className: 'totalRow',
          };
        }
        return (
          <div
            style={{
              width: 160,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}>
            {text}
          </div>
        );
      },
    },
    {
      title: '时间',
      dataIndex: 'dayStr',
      key: 'dayStr',
      align: 'center',
      fixed: 'left',
      width: 150,
      render: (text, record, index) => {
        const obj = {
          children: text,
          props: {},
          className: '',
        };
        if (index === list.length - 1) {
          obj.props.colSpan = 0;
          obj.className = 'totalRow';
        }
        return obj;
      },
    },
    {
      title: '话务',
      children: [
        {
          title: '任务量',
          dataIndex: 'totalNum',
          width: 180,
          align: 'center',
        },
        {
          title: '外呼量',
          dataIndex: 'calledNum',
          width: 180,
          align: 'center',
        },
        {
          title: '接通量',
          dataIndex: 'answerNum',
          width: 180,
          align: 'center',
        },
        {
          title: '接通率',
          dataIndex: 'answerRate',
          width: 180,
          align: 'center',
        },
      ],
    },
    {
      title: '挂机原因次数',
      key: 'hangupExtMap',
      children: [
        {
          title: '客户挂机',
          dataIndex: 'hangupExtMap.user',
          width: 100,
          align: 'center',
        },
        {
          title: '未识别挂机',
          dataIndex: 'hangupExtMap.unknown',
          width: 100,
          align: 'center',
        },
        {
          title: '超时挂机',
          dataIndex: 'hangupExtMap.timeout',
          width: 100,
          align: 'center',
        },
        {
          title: '结束挂机',
          dataIndex: 'hangupExtMap.normal',
          width: 100,
          align: 'center',
        },
        {
          title: '其他挂机',
          dataIndex: 'hangupExtMap.others',
          width: 100,
          align: 'center',
        },
      ],
    },
    {
      title: '交互',
      children: [
        {
          title: '无效会话数',
          dataIndex: 'noUsefulInteractNum',
          width: 130,
          align: 'center',
        },
        {
          title: '一轮有效会话数',
          dataIndex: 'oneUsefulInteractNum',
          width: 130,
          align: 'center',
        },
        {
          title: '多轮有效会话数',
          dataIndex: 'moreUsefulInteractNum',
          width: 130,
          align: 'center',
        },
        {
          title: '多轮会话数',
          dataIndex: 'moreInteractNum',
          width: 130,
          align: 'center',
        },
        {
          title: '未识别次数',
          dataIndex: 'unknownNum',
          key: 'unknownNum',
          width: 130,
          align: 'center',
        },
        {
          title: '超时未说话次数',
          dataIndex: 'timeoutNum',
          key: 'timeoutNum',
          width: 130,
          align: 'center',
        },
      ],
    },
    {
      title: '有效标签',
      key: 'labelDistinctCountMap',
      dataIndex: 'labelDistinctCountMap',
      width: 250,
      ellipsis: true,
      render: text => (text && text.length ? text.join('、') : '--'),
    },
  ];

  // 统计列表
  getList = () => {
    const { actions } = this.props;
    const {
      pagination,
      values: { date = [], taskId = [] },
      columns,
      totalColumn,
    } = this.state;
    const params = {
      pageNum: pagination.current,
      pageSize: pagination.pageSize,
      startTime: date.length ? Date.parse(date[0]) : '',
      endTime: date.length ? Date.parse(date[1]) : '',
      taskId,
    };
    this.setState({ loading: true, list: [] });
    actions.postTaskStatisticList(params).then(res => {
      const { data, code } = res.payload;
      if (code === 200) {
        const dataList = data.list;
        this.setState({ loading: false, total: data.total }, () => {
          const totalList = JSON.parse(JSON.stringify(dataList));
          totalList.push(totalColumn);
          this.setState({ list: totalList }, () => {
            const defaultCoulumnsList = this.defaultCoulumns(totalList);
            let finallyCoulums = [];
            if (columns.length !== 0) {
              defaultCoulumnsList.splice(3, defaultCoulumnsList.length - 3);
              columns.splice(0, 3);
              finallyCoulums = defaultCoulumnsList.concat(columns);
            } else {
              finallyCoulums = defaultCoulumnsList;
            }
            this.setState({
              columns: finallyCoulums,
            });
          });
        });
      } else {
        this.setState({ loading: false, list: [], total: 0 });
      }
      inSearch = false
    }).catch(err => {
      inSearch = false
    });
  };

  getTotal = () => {
    const { actions } = this.props;
    const {
      pagination,
      values: { date = [], taskId = [] },
    } = this.state;
    const params = {
      pageNum: pagination.current,
      pageSize: pagination.pageSize,
      startTime: date.length ? Date.parse(date[0]) : '',
      endTime: date.length ? Date.parse(date[1]) : '',
      taskId,
    };
    inSearch = true
    actions.postTaskStatisticList(params).then(res => {
      const { data, code } = res.payload;
      if (code === 200 && data.list.length !== 0) {
        actions.getTotal(params).then(res => {
          const { data, code } = res.payload;
          if (code === 200) {
            this.setState(
              {
                totalColumn: data,
                list: [],
              },
              () => {
                this.getList();
              },
            );
          } else {
            inSearch = false
          }
        }).catch(err => {
          inSearch = false
        });
      } else {
        inSearch = false
      }
    }).catch(err => {
      inSearch = false
    });
  }

  // 搜索
  handleFilter = fields => {
    const { pagination } = this.state;
    this.setState(
      {
        values: fields,
        pagination: { ...pagination, current: 1 },
        totalColumn: {},
        list: [],
      },
      () => {

        !inSearch && this.getTotal();
      },
    );
  };

  // 表格翻页
  onPageChange = (page, pageSize) => {
    const { pagination } = this.state;
    const pager = { ...pagination };
    pager.current = page;
    pager.pageSize = pageSize;
    this.setState(
      {
        pagination: pager,
      },
      () => {
        this.getList();
      },
    );
  };

  onPageSize = (current, size) => {
    const { pagination } = this.state;
    const pager = { ...pagination };
    pager.current = current;
    pager.pageSize = size;
    this.setState(
      {
        pagination: pager,
      },
      () => {
        this.getList();
      },
    );
  };

  handleVisibleChange = () => {
    const { visible } = this.state;
    this.setState({ visible: !visible });
  };

  // 展示列
  filterColumns = (columns, select) => {
    const { list } = this.state;
    columns.splice(0, 2);
    columns.unshift(
      {
        title: '序号',
        dataIndex: 'number',
        key: 'number',
        width: 60,
        fixed: 'left',
        render: (text, record, index) => {
          const obj = {
            children: index + 1,
            props: {},
          };
          if (index === list.length - 1) {
            obj.props.colSpan = 0;
          }
          return obj;
        },
        },
      {
        title: '任务名称',
        dataIndex: 'taskName',
        key: 'taskName',
        fixed: 'left',
        ellipsis: true,
        width: 190,
        render: (text, record, index) => {
          if (index === list.length - 1) {
            return {
              children: <div style={{ textAlign: 'center' }}>总计</div>,
              props: {
                colSpan: 3,
              },
            };
          }
          return (
            <div
              style={{
                width: 160,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}>
              {text}
            </div>
          );
        },
      },
      {
        title: '时间',
        dataIndex: 'dayStr',
        key: 'dayStr',
        align: 'center',
        fixed: 'left',
        width: 150,
        render: (text, record, index) => {
          const obj = {
            children: text,
            props: {},
          };
          if (index === list.length - 1) {
            obj.props.colSpan = 0;
          }
          return obj;
        },
      },
    );
    let width = 250;
    columns.forEach(item => {
      if (item.key === 'jiaohu') {
        width += item.children.length * 130;
      } else if (item.key === 'hangupExtMap') {
        width += item.children.length * 100;
      } else if (item.key === 'huawu') {
        width += item.children.length * 180;
      } else if (item.key === 'dayStr') {
        width += 150;
      } else if (
        item.key === 'labelDistinctCountMap' ||
        item.key === 'labelCountMap'
      ) {
        width += 250;
      }
    });
    this.setState({ visible: false, columns, tableWidth: width, select });
  };

  // 导出excel
  export = () => {
    this.setReloadModalVisible();
  };

  exportTask = taskName => {
    const {
      values: { date = [], taskId = [] },
      select,
    } = this.state;
    const { actions } = this.props;
    const user = window.localStorage.getItem('user') || '{}';
    const vccId = JSON.parse(user).profile?.vcc_id;
    const deptId = JSON.parse(user).profile?.dept_id;
    const userId = JSON.parse(user).profile?.user_id;
    const urlParmas = {
      syncTaskName: taskName,
      vccId,
      deptId,
      userId,
      startTime: date.length ? Date.parse(date[0]) : '',
      endTime: date.length ? Date.parse(date[1]) : '',
      taskId: taskId.length ? taskId : [],
      select,
    };
    actions.exportTask(urlParmas).then(res => {
      if (res.payload.code === 200) {
        message.success('创建导出任务成功！');
      } else {
        message.success(res.payload.msg);
      }
    });
  };

  // 设置重新创建弹框显示隐藏
  setReloadModalVisible = () => {
    const { reloadModalVisible } = this.state;
    this.setState({
      reloadModalVisible: !reloadModalVisible,
    });
  };

  render() {
    const { taskNameOptions, login } = this.props;
    const {
      pagination,
      total,
      loading,
      list,
      // total,
      visible,
      columns,
      tableWidth,
      reloadModalVisible,
      pageType,
    } = this.state;
    const showTotal = total => {
      return `共${total}条`;
    };
    return (
      <div className="taskManageStatistic">
        <BaseContentMainHeader title="任务统计">
          <Form layout="inline">
            {
              login.permissionsList.includes('taskManageStatistic.export') ?
                <FormItem>
                  <Button type="primary" onClick={this.export}>
                    导出excel
                  </Button>
                </FormItem>
                : null}
          </Form>
        </BaseContentMainHeader>
        <Filter handleFilter={this.handleFilter}>
          <NormalFilter>
            <NormalFilter.Item label="时间范围" initialValue={[moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]} field="date">
              <RangePicker showTime format="YYYY-MM-DD HH:mm:ss" />
            </NormalFilter.Item>
            <NormalFilter.Item label="任务名称" field="taskId">
              <Select
                allowClear
                placeholder="请选择"
                mode="multiple"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }>
                {Array.isArray(taskNameOptions)
                  ? taskNameOptions.map(({ taskId, taskName }) => (
                    <Option
                      value={taskId && parseInt(taskId, 10)}
                      key={taskId}>
                      {taskName}
                    </Option>
                  ))
                  : null}
              </Select>
            </NormalFilter.Item>
          </NormalFilter>
        </Filter>
        <div className="table-area">
          <BaseTable
            extraHeight={50}
            dataSource={list}
            columns={columns}
            loading={loading}
            scroll={{ x: tableWidth }}
            rowKey={record => record.id}
            bordered
            size="small"
          />
          <Pagination
            size="small"
            total={total}
            showTotal={showTotal}
            showSizeChanger
            showQuickJumper
            current={pagination.current}
            pageSize={pagination.pageSize}
            onChange={this.onPageChange}
            onShowSizeChange={this.onPageSize}
            pageSizeOptions={['10', '20', '30', '50', '100']}
          />
          <Popover
            title={false}
            content={<FilterTree cfunOk={this.filterColumns} />}
            trigger="click"
            placement="bottomRight"
            visible={visible}
            onVisibleChange={this.handleVisibleChange}>
            <Icon type="unordered-list" className="table-btn" />
          </Popover>
        </div>
        {reloadModalVisible ? (
          <ReloadModal
            getTableList={this.getCustomizeTableList}
            setReloadModalVisible={this.setReloadModalVisible}
            pageType={pageType}
            exportTask={this.exportTask}
          />
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = ({ taskManageDetail, login }) => ({
  taskNameOptions: taskManageDetail.taskNameOptions,
  login
});

const mapDispatchToProps = dispatch => {
  return {
    DetailActions: bindActionCreators(tDetailActions, dispatch),
    actions: bindActionCreators(tStatisticActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Statistic);
